import { isArr } from 'lib/util'

/**
 * Validator - Not Empty Attribute
 *
 * @param {string} value - value to validate
 * @param {Object} options - validator options
 * @returns {string} value - validated value
 */
export default (value, options) => {
  const { error } = options

  if ((isArr(value) && value.length) || value !== undefined) {
    return value
  } else {
    throw TypeError(error)
  }
}
